import shortid from 'shortid'

let envSettings = {
  development: {
    baseTrackUrl: '//tracker.localhost/',
    trackUrlV2: '//127.0.0.1:8008/',
    leadInitUrl: '//init.localhost/',
    leadInitUrlV2: '//initialize.localhost:8008/',
    proto: 'http:'
  },
  production: {
    baseTrackUrl: '//track.leadhit.io/',
    trackUrlV2: '//track-api.leadhit.io/',
    leadInitUrl: '//init.leadhit.io/',
    leadInitUrlV2: '//initialize.leadhit.io/',
    proto: 'https:'
  },
  watching: {
    baseTrackUrl: '//tracker.localhost/',
    trackUrlV2: '//127.0.0.1:8008/',
    leadInitUrl: '//init.localhost/',
    leadInitUrlV2: '//initialize.localhost:8008/',
    proto: 'http:'
  }
}

let Store = function () {
  this.state = {
    'isFirstVisit': null,
    'isFirstSubmit': null,
    'isOfferPage': null,
    'pageOfferAvailable': null,
    'proto': envSettings[ENV].proto,
    'orderButtons': [],
    'debug': localStorage.getItem('leadhit_secret'),
    'baseTrackUrl': envSettings[ENV].baseTrackUrl,
    'trackUrlV2': envSettings[ENV].trackUrlV2,
    'leadInitUrl': envSettings[ENV].leadInitUrl,
    'leadInitUrlV2': envSettings[ENV].leadInitUrlV2,
    'old_browser': !document.getElementsByClassName,
    'disabledForms': [],
    'defaultDisabledForms': [
      '#id_popup_leadhit_wrapper_discount_form',
      '#id_popup_leadhit_blub_wrapper_discount_form',
      '#deferred-products__form',
      'form[action="lh_banner"]',
      'form[action="lh_banner_mobile"]',
      'form[action="lh_subscribe_target"]',
      'form[action="lh_subscribe_window"]',
      '#subscribe__type__window form.subscribe__form',
      '#subscribe__type__target form.subscribe__form'
    ],
    'domain': '',
    'pageID': shortid.generate(),
    'params': { 'popup': false },
    'tickInterval': 60000,
    '__forms': [], // form submits storage
    'siteSettings': {},
    'existingForms': [],
    'formFields': [
      {
        'name': 'name',
        'title': 'Имя'
      },
      {
        'name': 'last_name',
        'title': 'Фамилия'
      },
      {
        'name': 'email',
        'title': 'Почта'
      },
      {
        'name': 'sex',
        'title': 'Пол'
      },
      {
        'name': 'birthday',
        'title': 'Дата рождения'
      },
      {
        'name': 'phone',
        'title': 'Телефон'
      },
      {
        'name': 'index',
        'title': 'Индекс'
      },
      {
        'name': 'region',
        'title': 'Регион'
      },
      {
        'name': 'country',
        'title': 'Страна'
      },
      {
        'name': 'city',
        'title': 'Город'
      },
      {
        'name': 'address',
        'title': 'Адрес'
      },
      {
        'name': 'fax',
        'title': 'Факс'
      },
      {
        'name': 'position',
        'title': 'Должность'
      },
      {
        'name': 'company',
        'title': 'Название компании'
      },
      {
        'name': 'order_id',
        'title': 'Номер заказа'
      },
      {
        'name': 'misc',
        'title': 'Дополнительная информация'
      },
      {
        'name': 'cart_sum',
        'title': 'Сумма заказа'
      },
      {
        'name': 'Not used',
        'title': 'Не используется'
      },
      {
        'name': 'sub_type',
        'title': 'Тип подписки'
      },
      {
        'name': 'discount_size',
        'title': 'Размер скидки'
      },
      {
        'name': 'add_1',
        'title': 'Дополнительное поле - 1'
      },
      {
        'name': 'add_2',
        'title': 'Дополнительное поле - 2'
      },
      {
        'name': 'add_3',
        'title': 'Дополнительное поле - 3'
      },
      {
        'name': 'add_4',
        'title': 'Дополнительное поле - 4'
      },
      {
        'name': 'add_5',
        'title': 'Дополнительное поле - 5'
      },
      {
        'name': 'hidden',
        'title': 'Скрыто от пользователя'
      }
    ],
    'editableForm': null
  }
}

export default new Store()
